import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const updateEdiaryConfig = async ({ trialId, config }) => {
  const token = localStorage.getItem("token");

  const res = await axios.put(`${__API_URL__}/api/photos/ediary/config/${trialId}/`, config, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useUpdateEdiaryConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEdiaryConfig,
    onSuccess: (_, variables) => {
      toast.success("eDiary settings updated");
      queryClient.invalidateQueries({ queryKey: ["ediary_config", variables.trialId] });
      // The eDiary tab is labelled with the visit name, which follows the configured name
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update the eDiary settings");
    },
  });
};

export default useUpdateEdiaryConfigMutation;
